/**
 * Static app paths (no dynamic :params). Used to resolve /du/{token} on refresh
 * without relying only on browser storage. Dynamic paths still use localStorage.
 */
export const REGISTERED_STATIC_ROUTE_PATHS = [
  "/dashboard",
  "/update-password",
  "/profile",
  "/user/error-code",
  "/smsc/error-code",
  "/message",
  "/utilities/two-way",
  "/utilities/two-way-report",
  "/utilities/converter",
  "/utilities/subscription",
  "/subscription",
  "/utilities/edit/bulk",
  "/utilities/edit/schedule",
  "/approvals/sender/approved-reject",
  "/approvals/sender/log",
  "/reports/campaign/aborted",
  "/reports/campaign/schedule",
  "/reports/campaign/campaign",
  "/reports/summary/delivery",
  "/reports/summary/batch",
  "/reports/detailed/advanced",
  "/reports/detailed/content",
  "/reports/latency",
  "/reports/lookup",
  "/reports/consumption",
  "/reports/tps",
  "/reports/vendor-summary",
  "/address-book",
  "/template",
  "/wallet",
  "/downloads",
  "/developer/documentation",
  "/developer/sdk",
  "/company",
  "/billing",
  "/reports/aggregated",
  "/reports/profit",
  "/reports/coverage-report",
  "/reports/edr",
  "/approvals/bulk/approved-reject",
  "/approvals/bulk/log",
  "/utilities/pcaps",
  "/utilities/pcaps/list",
  "/firewall",
  "/sales",
  "/user",
  "/user/list",
  "/routing/edit",
  "/routing/copy",
  "/routing/sender/add",
  "/routing/sender/edit",
  "/vendor",
  "/user/limit",
  "/smsc/list",
  "/smsc/flag",
  "/smsc/status",
  "/smsc/limits",
  "/smsc/http",
  "/smsc/alert",
  "/smsc/looping",
  "/smsc/hlr",
  "/smsc/hlr-flag",
  "/smsc/hlr-status",
  "/smsc/blocking",
  "/smsc/schedule",
  "/smsc/special-settings",
  "/smsc/group-data",
  "/network",
  "/dlt/principleEntityID",
  "/dlt/templateDlt",
  "/routing/add",
  "/reports/performance/user",
  "/reports/performance/route",
  "/reports/blocked",
  "/reports/detailed/smsc",
  "/reports/delivery-advance",
  "/reports/batch-summary",
  "/reports/user-status",
  "/reports/submission",
  "/reports/transaction-history",
  "/reports/performance-user",
  "/reports/coverage",
  "/view/schedule",
  "/view/bulk",
  "/sales-list",
];
